export function dateFormater(date?: string | Date) {
  if (!date) return;
  // Exibe sempre em horário de Brasília, independente do fuso da máquina do usuário
  // (spec 029). O backend grava os instantes em UTC.
  const formater = new Intl.DateTimeFormat("pt-BR", {
    timeZone: "America/Sao_Paulo",
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  });
  if (typeof date === "string") {
    return formater.format(new Date(date));
  }
  return formater.format(date);
}
